import { render } from "./KashtabroShort.vue?vue&type=template&id=45eb698e"
import script from "./KashtabroShort.vue?vue&type=script&lang=js"
export * from "./KashtabroShort.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__